import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { ErrorComponent } from './common/error/error.component';
import { LoginComponent } from './common/login/login.component';
import { BaseComponent } from './common/base/base.component';
import { httpInterceptorProviders } from './_helpers/http.interceptor';
import { HttpClientModule, HttpRequest } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UnauthorizedComponent } from './common/unauthorized/unauthorized.component';
import { LanguageManagerService } from './_services/languagemanager.service';
import { TranslatePipe } from './_pipes/translate.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { DatePipe, registerLocaleData } from '@angular/common';
import { RouterModule, UrlSerializer } from '@angular/router';
import { MessageComponent } from './common/message/message.component';
import { ClientFileConfigurationComponent } from './client_file_configuration/client-file-configuration/client-file-configuration.component';
import { ContactDataComponent } from './components/enrollment/contact-data/contact-data.component';
import { DocumentDetailsComponent } from './components/enrollment/document-details/document-details.component';
import { JwtModule } from '@auth0/angular-jwt';
import { EnrollmentGuard } from './_guard/enrollment.guard';
import { AuthGuard } from './_guard/auth.guard';
import { LoginGuard } from './_guard/login.guard';
import { PwrecoveryComponent } from './common/login/pwrecovery/pwrecovery.component';
import { PwresetComponent } from './common/login/pwreset/pwreset.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { FileFormComponent } from './components/file-form/file-form.component';
import { LowerCaseUrlSerializer } from './_services/lowerCaseUrlSerializer.service';
import { ContactListComponent } from './components/contact-list/contacts-list.component';
import { DocumentsComponent } from './components/enrollment/documents/documents.component';
import { DownloadFileComponent } from './components/download-file/download-file.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { DisputesComponent } from './components/disputes/disputes.component';
import { DisputeDetailsComponent } from './components/disputes/details/dispute-details.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import localeEs from '@angular/common/locales/es';
import { DisputesManagementComponent } from './components/disputes/managment/disputes-management.component';
import { StartupComponent } from './common/startup/startup.component';
import { DashboardComponent } from './common/dashboard/dashboard.component';

import { ZoneCheckComponent } from './common/zonecheck.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';



import { provideZoneChangeDetection } from '@angular/core';
import { ProfileComponent } from './components/profile/profile.component';
import { HelpComponent } from './components/help/help.component';
import { LogoutComponent } from './common/logout/logout.component';
import { SsoComponent } from './common/login/sso/sso.component';
import { EndEnrollmentComponent } from './components/enrollment/end-enrollment/end-enrollment.component';
import { StorageService } from './_services/storage.service';
import { FallbackErrorComponent } from './common/fallbackerror/fallback-error.component';
import { TableConfigurationComponent } from './common/table-configuration/table-configuration.component';
import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';


registerLocaleData(localeEs, 'es-ES');

@NgModule({
  declarations: [
    ZoneCheckComponent,
    AppComponent,
    TranslatePipe,
    StartupComponent,
    FallbackErrorComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ErrorComponent,
    LoginComponent,
    LogoutComponent,
    SsoComponent,
    BaseComponent,
    UnauthorizedComponent,
    MessageComponent,
    DisputesComponent,
    DisputeDetailsComponent,
    DisputesManagementComponent,
    ClientFileConfigurationComponent,
    ContactDataComponent,
    DocumentDetailsComponent,
    PwrecoveryComponent,
    PwresetComponent,
    DynamicFormComponent,
    FileFormComponent,
    ContactListComponent,
    DocumentsComponent,
    DownloadFileComponent,
    FileUploadComponent,
    DashboardComponent,
    ProfileComponent,
    HelpComponent,
    EndEnrollmentComponent,
    TableConfigurationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatIconModule,
    CdkDropList, CdkDrag,
    MatExpansionModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatSelectModule,
    MatDividerModule,
    JwtModule.forRoot({
        config: {
            tokenGetter: tokenGetter,
            // allowedDomains: [''], // dominio
            // disallowedRoutes: [''], // rutas que no requieren autenticación
        },
    }),
],
  exports:[
    DownloadFileComponent
  ],
  providers: [
    provideZoneChangeDetection({
      // opcional: mismas opciones que en BootstrapOptions
      eventCoalescing: true,
      runCoalescing: true
    }),
    httpInterceptorProviders,
    LanguageManagerService,
    DatePipe,
    AuthGuard,
    EnrollmentGuard,
    LoginGuard,
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
function tokenGetter(request?: HttpRequest<any>): string | Promise<string> {
  return new StorageService().getToken();
}

